import { render } from "./EmailService.vue?vue&type=template&id=001ca76a&scoped=true"
import script from "./EmailService.vue?vue&type=script&lang=js"
export * from "./EmailService.vue?vue&type=script&lang=js"

import "./EmailService.vue?vue&type=style&index=0&id=001ca76a&lang=scss&scoped=true"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001ca76a"]])

export default __exports__